module.exports = __webpack_public_path__ + "img/product-advantage2.f71146f0.svg";